import { AnalysisToolbarCTA } from '@modules/analysis/components/AnalysisToolbar/types';
import { FlatMenuList } from '@modules/common/components/FlatMenuList/FlatMenuList';
import { MenuItemOptions } from '@modules/common/components/KebabMenu/types';
import { Box, Stack } from '@mui/material';
import { ReactNode } from 'react';

interface AnalysisToolbarProps {
  leftActions?: AnalysisToolbarCTA[];
  rightActions?: AnalysisToolbarCTA[];
  moreActions?: MenuItemOptions;
  bannerNode?: ReactNode;
  className?: string;
}

export const AnalysisToolbar = ({
  leftActions,
  rightActions,
  moreActions,
  bannerNode,
  className,
}: AnalysisToolbarProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      position="relative"
      className={className}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        {leftActions?.map((action) => (
          <Box key={action.key}>{action.component}</Box>
        ))}
      </Stack>
      {bannerNode && (
        <Box
          position="absolute"
          top={-15}
          left="50%"
          sx={{
            transform: 'translate(-50%,0)',
            zIndex: 2000,
          }}
        >
          {bannerNode}
        </Box>
      )}
      <Stack direction="row" alignItems="center" spacing={1}>
        {rightActions?.map((action) => (
          <Box key={action.key}>{action.component}</Box>
        ))}
        {moreActions && (
          <FlatMenuList
            listItems={moreActions}
            buttonProps={{ className: 'analysis-toolbar-more-actions-button' }}
          />
        )}
      </Stack>
    </Stack>
  );
};
